import {modalController} from "@ionic/vue";
import PdfViewerModal from "@/components/html/PdfViewerModal.vue";


function setup(pdf) {
    let url = pdf.getAttribute('href');

    // check the file extension to only open pdf file on pdf modal.
    if (url != null && url.toLowerCase().endsWith(".pdf")) {

        /*
         globalFunctions.js has `multipleChoiceLabelClicked` function that opens url in the second thab. however,
         we don't want to download the pdf file when pdf viewer is opening.
         Hence, we had to inject 'No-external-link' class to skip the download.
        */
        pdf.classList.add('no-external-link');

        // set PDF viewer modal
        pdf.onclick = function (e) {
            e.preventDefault();
            __openPDFModal(url)
        }
    }
}


async function __openPDFModal(url) {
    const modal = await modalController.create({
        component: PdfViewerModal,
        cssClass: 'pdf-viewer-modal'
    });
    modal.componentProps = {
        url: url,
        obj: modal
    };
    return modal.present();
}


export default {setup}